import React from "react";
import { Link } from "react-router-dom";

const AdvertisingAgent = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              Turn Everyday Sharing into Meaningful Rewards
            </h5>
            <p className="text-dark opacity-75">
              Becoming a TopCoin UK Advertising Agent is simple and rewarding.
              Agents receive independent TopCoin reward for introducing new
              customers and participating businesses to the TopCoin network.
            </p>
            <p className="text-dark opacity-75">
              Each time a referred user shops with participating businesses and
              collects TopCoin the Advertising Agent also receives matched
              reward TopCoin from our advertising programme as a thank-you for
              helping grow the community.
            </p>
            <p className="text-dark opacity-75">
              These rewards are loyalty-based TopCoin units and are completely
              separate from customer TopCoin balances or customer bonus rewards.
              The Advertising Agent reward system is an independent loyalty and
              promotional programme created specifically for agents.
            </p>

            <h5 className="title_text text-dark">The More You Share,</h5>
            <h5 className="title_text text-dark">
              The More Advertising Reward Units You Receive
            </h5>
            <p className="text-dark opacity-75">
              Everyone you refer becomes part of your Advertising Reward Chain.
              As your network grows, your TopCoin advertising rewards grow with
              it — simply through participation and referrals within the
              platform.
            </p>

            <p className="text-dark opacity-75">
              <strong>Example:</strong>
              <br />
              For every <strong>20,000 Topcoin</strong> collected through your
              Advertising Chain activity, you will receive a reward value of{" "}
              <strong>£100</strong> into your Advertising Agent Reward Wallet —
              as part of our loyalty advertising programme.
            </p>

            <h5 className="title_text text-dark">
              Why Become a TopCoin UK Advertising Agent?
            </h5>
            <ul>
              <li className="text-dark opacity-75">
                Receive TopCoin advertising rewards by introducing new users and
                businesses
              </li>
              <li className="text-dark opacity-75">
                Build a growing reward network linked to verified shopping
                activity
              </li>
              <li className="text-dark opacity-75">
                No purchasing, no investment, no gambling
              </li>
              <li className="text-dark opacity-75">
                Free to join and free to participate
              </li>
            </ul>

            <p className="text-dark opacity-75">
              Joining is easy — simply register, receive your referral tools,
              and start sharing TopCoin UK with others. TopCoin UK — Where
              Participation is Rewarded
            </p>

            <h5 className="title_text text-dark">
              TopCoin UK — Where Participation is Rewarded
            </h5>
            <p className="text-dark opacity-75">
              Join a smarter way to support businesses and benefit from a
              structured loyalty growth system.
              <br />
            </p>
            <h5 className="title_text text-dark">
              TopCoin UK — Your Voice Helps Build Value
            </h5>
            <p className="text-dark opacity-75">
              No speculation. No financial risk. Just structured loyalty
              participation rewards.
            </p>

            <h5 className="title_text text-dark">
              For Young Agents (Ages 16+)
            </h5>
            <p className="text-dark opacity-75">
              Young participants must have parental or guardian consent to join
              the Advertising Agent programme.
              </p>
             <p className="text-dark opacity-75">
              IMPORTANT COMPLIANCE NOTE (Built-In)
              </p>
              <p className="text-dark opacity-75">
              TopCoin UK Advertising Agent Rewards are loyalty-based promotional
              rewards, not financial returns, investments, interest, or profit
              schemes. Rewards are generated solely through the TopCoin UK
              advertising and loyalty ecosystem.
            </p>

            {/* NEW CARD SECTION */}
            <div className="d-flex justify-content-center my-5">
              <div
                className="card shadow-sm border-0"
                style={{ maxWidth: "1000px", width: "100%" }}
              >
                <div className="card-body text-center">
                  <h5
                    className="mt-4 mb-4"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    What Happens After You Join?
                  </h5>

                  <p
                    className="card-text mb-4 ps-3 pe-3 opacity-75"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    Once you join as a customer, you can start inviting others.
                    After you have referred new customers, you can apply to
                    become an Advertising Agent and unlock rewards as your
                    network grows.
                  </p>

                  <ul
                    className="opacity-75 ms-3 ps-5 pe-5 text-start"
                    style={{ display: "inline-block" }}
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    <li className="mb-3">
                      <strong>Step 1 – Join as a Customer: </strong>
                      Click the button to create your account instantly.
                    </li>
                    <li className="mb-3">
                      <strong>Step 2 – Invite New Customers: </strong>
                      After joining, share your referral link and invite family
                      and friends to join Topcoin UK.
                    </li>
                    <li className="mb-3">
                      <strong>Step 3 – Request for Advertising Agent: </strong>
                      Once you have invited customers, submit your request to
                      become an Advertising Agent.
                    </li>
                    <li className="mb-3">
                      <strong>Step 4 – Start Earning: </strong>
                      Earn rewards every time your invited customers join and
                      shop.
                    </li>
                  </ul>

                  <div className="mt-3 mb-5">
                    <Link className="ico_creative_btn" to="/sign_up">
                      <span className="btn_wrapper px-5 py-0">
                        <span className="btn_label">Join Now</span>
                        <span className="btn_icon_right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="currentColor"
                          >
                            <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                          </svg>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingAgent;
